import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ReturnUrlService } from '../services/return-url.service';
import { map, take } from 'rxjs/operators';

export const studentAuthGuard: CanActivateFn = (route, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const returnUrlService = inject(ReturnUrlService);

  return auth.isLoggedIn$.pipe(
    take(1),
    map(isLoggedIn => {
      if (isLoggedIn) return true;

      returnUrlService.setReturnUrl(state.url);
      return router.createUrlTree(['/login']);
    })
  );
};